import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { cleanEmpty } from 'utils/genericFunctions';
import { ConsultarParametrosLocalidadeRequest, Types } from './types';

// ACTIONS
import {
	consultarParametrosLocalidadeSuccess,
	consultarParametrosLocalidadeFailure,
} from './actions';

function* consultarParametrosLocalidade(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: ConsultarParametrosLocalidadeRequest } =
		request;

	let body = { ...payload };

	delete body.current;

	body = cleanEmpty(body) as ConsultarParametrosLocalidadeRequest;

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_SGU_API,
		`parametros-localidades`,
		body,
	);

	if (response.status === 200) {
		yield put(consultarParametrosLocalidadeSuccess(response));
	} else {
		yield put(consultarParametrosLocalidadeFailure());
	}
}

export default all([
	takeLatest(
		Types.CONSULTAR_PARAMETROS_LOCALIDADE,
		consultarParametrosLocalidade,
	),
]);
